import type { ReactNode } from 'react';
import styled from 'styled-components';

import { InfoTitle } from 'components/Toolkit/InfoTitle/InfoTitle';
import type { InfoTitleProps } from 'components/Toolkit/InfoTitle/InfoTitle';
import { WhitePanel } from 'components/Toolkit/WhitePanel/WhitePanel';

export interface PromoPanelProps extends InfoTitleProps {
  renderButton: ReactNode;
  className?: string;
}

const SWhitePanel = styled(WhitePanel)`
  padding: ${({ theme }) => theme.spacing.M24};
`;

const SInfoTitle = styled(InfoTitle)`
  margin-bottom: ${({ theme }) => theme.spacing.M16};
`;

function PromoPanel({
  title,
  illustration,
  listItems,
  renderButton,
  className,
}: PromoPanelProps) {
  return (
    <SWhitePanel className={className}>
      <SInfoTitle
        title={title}
        illustration={illustration}
        listItems={listItems}
        variant="SMALL"
      />
      {renderButton}
    </SWhitePanel>
  );
}

export { PromoPanel };
